import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acb18258"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"loading\" data-v-acb18258><div class=\"loader-inner ball-pulse-sync\" data-v-acb18258><img src=\"/img/nico_white.svg\" alt=\"ローディング画像\" data-v-acb18258><img src=\"/img/nico_white.svg\" alt=\"ローディング画像\" data-v-acb18258><img src=\"/img/nico_white.svg\" alt=\"ローディング画像\" data-v-acb18258></div><p class=\"text-center loading-text\" data-v-acb18258>Now loading...</p></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]

import { useStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingView',
  setup(__props) {

const store = useStore()

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3, 512)), [
    [_vShow, !_unref(store).state.loading]
  ])
}
}

})